import { render } from "./detail.vue?vue&type=template&id=b40cfb7a&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=b40cfb7a&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=b40cfb7a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40cfb7a"]])

export default __exports__